import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"
import {get} from "lodash"

import {question as questionFragment} from "@irati-web/insights/src/graph/question"

import {Query} from "../"
import addHistoricalDataToQuestions from "../../../utils/question/addHistoricalDataToQuestions"
import {ASCEDING_ORDER_VALUE, CREATED_AT_VALUE, FIFO_VALUE} from "../../../utils/constants/fields"


export const query = gql`
  query QuestionsAnalysis(
      $tenant: String!,
      $scheduleId: String!,
      $team: String,
      $driverId: String,
      $minOpenedAt: String,
      $maxOpenedAt: String,
      $withQuestionDriver: Boolean = false,
      $driverUuid: String
      $orderBy: String
      $orderDirection: String
    ) {
    questions: questionsV2(
        cycleUuid: $scheduleId,
        teamId: $team,
        minOpenedAt: $minOpenedAt,
        maxOpenedAt: $maxOpenedAt,
        driverUuid: $driverUuid,
        tenantUuid: $tenant,
        orderBy: $orderBy,
        orderDirection: $orderDirection
      ) {
        results {
          ${questionFragment}
            questionStats: questionStatsV2(
            minOpenedAt: $minOpenedAt,
            maxOpenedAt: $maxOpenedAt,
            driverId: $driverId,
            scheduleId: $scheduleId,
            team: $team,
            tenant: $tenant
          ) {
            answers {
              value
              count
            }
            timesSkipped
            timesAnswered
            timesSelected
            answersAverage
          }
        }
      }
  }`

const QuestionsQuery = ({children, tenant, schedule, filters, variables, context, ...props}) => {
  const {id: scheduleId, nthSurvey, preferences: {questionSelectionType}} = schedule
  const {teamId: team, driverId, time: minOpenedAt} = filters
  const fifoOrder = {orderBy: CREATED_AT_VALUE, orderDirection: ASCEDING_ORDER_VALUE}
  const defaultOrder = questionSelectionType === FIFO_VALUE ? fifoOrder : {}
  const vars = {tenant, scheduleId, team, driverId, minOpenedAt, ...defaultOrder, ...variables}
  const maxOpenedAt = get(nthSurvey, "openedAt")
  const historicalProps = {variables: {...vars, maxOpenedAt}, useLoader: false, context}

  return (
    <Query {...props} historicalProps={historicalProps} variables={vars} query={query} context={context}>
      {({data = {}, historicalData = {}, ...apolloState}) => {
        const questions = addHistoricalDataToQuestions(data, historicalData)
        return children({questions, ...apolloState})
      }}
    </Query>
  )
}

QuestionsQuery.propTypes = {
  children: PropTypes.func.isRequired
}


export default QuestionsQuery
